/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Content"
  
}) {
  let isMedia = useIsMedia()
let smsMessageValueData = fromData.useDataFormat({ viewPath,
context: 'sms',
path: 'message',
format: fromFormat.textWithLinks,
})
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 wordBreak="break-word"
 size={isMedia.mobile ? "small" : "large"}
 marginBottom={4}
 data="sms.message"
 format="/Data/format.js textWithLinks"
 text={smsMessageValueData}
/>
{children}
</React.Fragment>)
}